import { LookupTableType } from '../enums';

export interface OptionValue {
  id: string;
  text: string;
  type?: LookupTableType;
  description?: string;
  code?: string;
}
